<template>
  <div>
    <Row :gutter="10">
      <i-col :md="24" :lg="24" style="margin-bottom: 10px;">
        <Card>
          <Alert banner closable>搜索支持全局搜索，多条件搜索时请使用“|”作为条件分隔符</Alert>
          <div class="search-con search-con-top">
            <Input class="search-input" v-model="searchVal" style="padding:5px;" placeholder="输入关键字全局搜索"
                   @on-enter="searchinput"/>
            <slot name="new_btn">
              <Button type="primary" @click="editModal('', 'post', '新增')" class="search-btn">新增</Button>
            </slot>
            <Button type="error" class="search-btn" @click="handlerDelete">批量删除</Button>
          </div>
          <Spin size="large" fix v-if="spinShow"></Spin>
          <Table v-loading.fullscreen.lock="fullscreenLoading" height="670" size="small" ref="selection" border
                 :columns="columns" :data="tableData"
                 @on-selection-change="handleSelectChange"></Table>
          <div style="margin: 10px; overflow: hidden">
            <div style="float: left;">
              <Page :total="pageTotal" :current="pageNum" :page-size="pageSize" :page-size-opts=[15,35,50,100]
                    show-sizer show-total @on-change="changePage" @on-page-size-change="handlePageSize">
              </Page>
            </div>
          </div>
          <Modal v-model="modalMap.modalVisible" :title="modalMap.modalTitle" :loading=true :footer-hide=true
                 :mask-closable=false>
            <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
              <FormItem
                label="业务名称"
                prop="bname"
              >
                <Input
                  v-model="formValidate.bname"
                  placeholder="请输入业务名称"
                ></Input>
              </FormItem>
              <FormItem
                label="业务类型"
                prop="btype"
              >
                <el-select
                  v-model="formValidate.btype"
                  filterable
                  default-first-option
                  placeholder="请选择业务类型">
                  <el-option
                    v-for="item in btypeList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem
                label="备注说明"
                prop="remark"
              >
                <Input
                  v-model="formValidate.remark"
                  placeholder="请输入备注说明"
                ></Input>
              </FormItem>
              <FormItem>
                <Button
                  type="primary"
                  @click="handleSubmit('formValidate')"
                >提交
                </Button>
                <Button
                  @click="handleReset('formValidate')"
                  style="margin-left: 8px"
                >重置
                </Button>
              </FormItem>
            </Form>
          </Modal>
        </Card>
      </i-col>
    </Row>
  </div>
</template>
<script>

import {
  getHrbussinessconfiglist,
  operationHrbussinessconfig,
} from '@/api/hr/hrbussinessconfig.js'
import {getsysparameterList} from "@/api/system/sys_parameter";

let moment = require("moment");
export default {
  data() {
    return {
      spinShow: false,
      fullscreenLoading: false,
      btypeList: [],
      formValidate: {},
      searchVal: "",
      tableData: [],
      modalMap: {
        modalVisible: false,
        modalTitle: "新建"
      },
      tableSelectIdList: [],
      editModalData: "",
      pageNum: 1, // 当前页码
      pageTotal: 0, // 数据总数
      pageSize: 15, // 每页条数

      ruleValidate: {
        bname: [
          {
            required: true,
            message: "业务名称不能为空",
            trigger: "blur"
          }
        ]
,        btype: [
          {
            required: true,
            message: "请选择业务类型",
            trigger: "change"
          }
        ]
,
      },
      columns: [
        {
          type: 'selection',
          key: 'id',
          width: 60,
          fixed: 'left',
          align: 'center'
        },
        {
          title: "业务名称",
          key: "bname",
          align: "center",
          sortable: true        }
,        {
          title: "业务类型",
          key: "btype_CN",
          align: "center",
          sortable: true        }
,        {
          title: "备注说明",
          key: "remark",
          align: "center",
          sortable: true        }
,        {
          title: "操作",
          key: "handle",
          fixed: "right",
          width: 180,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.editModal(params.row, "post", "修改");
                    }
                  }
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.delData(params);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
    };
  },
  methods: {
    getHrbussinessconfiglist(key, value) {
      this.spinShow = true
      getHrbussinessconfiglist(this.pageNum, this.pageSize, key, value).then(res => {
        if (res.data.code === 0) {
          this.pageTotal = res.data.count
          this.tableData = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
        this.spinShow = false
      })
    },
    getParameterList() {
      getsysparameterList('hr_bussiness_config', 'btype').then(res => {
        if (res.data.code === 0) {
          this.btypeList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
    },
    handleSelectChange(val) {
      let SelectIdList = []
      val.forEach(item => {
        SelectIdList.push(item.id)
      })
      this.tableSelectIdList = SelectIdList
    },
    closeModal() {
      this.dialog.show = false
    },
    editModal(paramsRow, meth, mtitle) {
      this.modalMap.modalVisible = true;
      this.modalMap.modalTitle = mtitle;
      this.editModalData = meth;
      // this.getParameterList();
      var day2 = new Date();
      day2.setTime(day2.getTime());
      var s2 = day2.getFullYear() + "-" + (day2.getMonth() + 1) + "-" + day2.getDate() + " " + day2.getHours() + ":" + day2.getMinutes() + ":" + day2.getSeconds();
      if (paramsRow && paramsRow.id) {
        this.formValidate = {
          id: paramsRow.id,
          bname: paramsRow.bname,
          btype: paramsRow.btype,
          remark: paramsRow.remark,
        }
      } else {
        this.formValidate = {
          id: 0,
          bname: '',
          btype: '',
          remark: '',
        }
      }
    },
    handleSubmit(value) {
      this.$refs[value].validate((valid) => {
        if (valid) {
          setTimeout(() => {
            operationHrbussinessconfig(this.formValidate, this.editModalData).then(res => {
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)
                if (this.searchVal) {
                  this.getHrbussinessconfiglist(this.searchVal)
                } else {
                  this.getHrbussinessconfiglist()
                }
                this.modalMap.modalVisible = false
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
          }, 1000)
        } else {
          this.$Message.error("缺少必要参数");
        }
      })
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    },
    handlerDelete() {
      if (this.tableSelectIdList.length > 0) {
        if (confirm(`确定要批量删除选中数据嘛？ `)) {
          operationHrbussinessconfig({'id_list': this.tableSelectIdList}, 'delete').then(            res => {
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)
                this.getHrbussinessconfiglist(this.searchVal)
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
        }
      } else {
        this.$Message.info(`你总要选中点什么吧`)
      }
    },
    delData(params) {
      if (confirm(`确定要删除该信息吗？`)) {
        operationHrbussinessconfig(
          {
            'id': params.row.id
          },
          'delete'
        ).then(res => {
          if (res.data.code === 0) {
            this.$Message.success(`${res.data.msg}`)
            this.tableData.splice(params.index, 1)
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
      }
    },
    changePage(value) {
      this.pageNum = value
      if (this.searchVal) {
        this.getHrbussinessconfiglist(this.searchVal)
      } else {
        this.getHrbussinessconfiglist()
      }
    },
    handlePageSize(value) {
      this.pageSize = value
      this.pageNum = 1
      if (this.searchVal) {
        this.getHrbussinessconfiglist(this.searchVal)
      } else {
        this.getHrbussinessconfiglist()
      }
    },
    searchinput() {
      if (this.searchVal) {
        this.getHrbussinessconfiglist(this.searchVal)
      } else {
        this.getHrbussinessconfiglist()
      }
    }
  },
  watch: {
    searchVal(val) {
      this.searchVal = val
    }
  },
  mounted() {
    this.getParameterList();
    this.getHrbussinessconfiglist();
  }
}
</script>
<style lang="less" scoped>
.search-con {
  padding: 10px 0;
  .search {
    &-col {
      display: inline-block;
      width: 200px;
    }
    &-input {
      display: inline-block;
     width: 200px;
      margin-left: 2px;
    }
    &-btn {
      margin-left: 2px;
    }
  }
}
</style>
